import React, { useState, useContext, useEffect } from 'react'
import FieldsView from '@/product/components/organisms/Customized/User/FieldsView'
import {
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import Layout from '@/product/components/templates/Layout'
import AddBuyer from '@/product/components/organisms/Customized/User/Role/AddBuyer'
import { Button } from '@mui/material'
import { useHistory } from 'react-router-dom'
import EmailLogs from '@/product/views/Communications/EmailLogs'

const Logs = (props) => {
    let action = props.match.params.action
    return (
        <>
            <EmailLogs action={action} advFilters={true} />
        </>
    )
}

export default Logs
